module.exports = __webpack_public_path__ + "static/media/6-360.32c4ec73.jpg";